import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=6c6e1ca0"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=6c6e1ca0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6e1ca0')) {
      api.createRecord('6c6e1ca0', component.options)
    } else {
      api.reload('6c6e1ca0', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=6c6e1ca0", function () {
      api.rerender('6c6e1ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/frame/footer.vue"
export default component.exports